import React from 'react';

const Impressum = () => {
  return (
    <div className='col mx-auto'>
      <div className='mb-3 pb-3'>
        <div className='card outmost-card text-white bg-secondary mt-3 mb-4 mx-auto'>
          <div className='card-header'>Impressum</div>
          <div className='card-body text-left pb-0'>
            <p>
              <h5 className='mb-0'>Angaben Gemäß § 5 TM</h5>
              BlickSolutions GmbH
              <h5 className='mt-3 mb-0'>Geschäftsführung</h5>
              Calvin Blick
              <h5 className='mt-3 mb-0'>Sitz der Gesellschaft</h5>
              Freiherr-vom-Stein-Str. 50 65520 Bad Camberg
            </p>

            <p>
              <h5 className='mt-3 mb-0'>Niederlassung / Hauptbüro</h5>
              Warlramstraße 23 65510 Idstein
            </p>

            <p>
              <h5 className='mt-3 mb-0'>E-Mail</h5>
              <a href='mailto:contact@obc-client.de'>contact@obc-client.de</a>
              <h5 className='mt-3 mb-0'>Telefon</h5>
              +49 177 6261990‬
              <h5 className='mt-3 mb-0'>Ust-Id.</h5>
              DE334481762
              <h5 className='mt-3 mb-0'>Handelsregister</h5>
              Limburg HRB6333
            </p>

            <p>
              <h5 className='mt-3 mb-0'>Streitschlichtung</h5>
              Die Europäische Kommission stellt eine Plattform zur
              Online-Streitbeilegung (OS) bereit:
              https://ec.europa.eu/consumers/odr.
            </p>

            <p>
              Wir sind nicht bereit oder verpflichtet, an
              Streitbeteiligungsverfahren vor einer
              Verbraucherschlichtungsstelle teilzunehmen.
            </p>

            <p>
              <h5 className='mt-3 mb-0'>Haftung für Inhalte</h5>
              Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene
              Inhalte auf diesen Seiten nach den allgemeinen Gesetzen
              verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter
              jedoch nicht verpflichtet, übermittelte oder gespeicherte fremde
              Informationen zu überwachen oder nach Umständen zu forschen, die
              auf eine rechtswidrige Tätigkeit hinweisen.
            </p>

            <p>
              Verpflichtungen zur Entfernung oder Sperrung der Nutzung von
              Informationen nach den allgemeinen Gesetzen bleiben hiervon
              unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem
              Zeitpunkt der Kenntnis einer konkreten Rechtsverletzung möglich.
              Bei Bekanntwerden von entsprechenden Rechtsverletzungen werden wir
              diese Inhalte umgehend entfernen.
            </p>

            <p>
              <h5 className='mt-3 mb-0'>Haftung für Links</h5>
              Unser Angebot enthält Links zu externen Websites Dritter, auf
              deren Inhalte wir keinen Einfluss haben. Deshalb können wir für
              diese fremden Inhalte auch keine Gewähr übernehmen. Für die
              Inhalte der verlinkten Seiten ist stets der jeweilige Anbieter
              oder Betreiber der Seiten verantwortlich. Die verlinkten Seiten
              wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße
              überprüft. Rechtswidrige Inhalte waren zum Zeitpunkt der
              Verlinkung nicht erkennbar.
            </p>

            <p>
              Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist
              jedoch ohne konkrete Anhaltspunkte einer Rechtsverletzung nicht
              zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir
              derartige Links umgehend entfernen.
            </p>

            <p>
              <h5 className='mt-3 mb-0'>Urheberrecht</h5>
              Die durch die Seitenbetreiber erstellten Inhalte und Werke auf
              diesen Seiten unterliegen dem deutschen Urheberrecht. Die
              Vervielfältigung, Bearbeitung, Verbreitung und jede Art der
              Verwertung außerhalb der Grenzen des Urheberrechtes bedürfen der
              schriftlichen Zustimmung des jeweiligen Autors bzw. Erstellers.
              Downloads und Kopien dieser Seite sind nur für den privaten, nicht
              kommerziellen Gebrauch gestattet.
            </p>

            <p>
              Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt
              wurden, werden die Urheberrechte Dritter beachtet. Insbesondere
              werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie
              trotzdem auf eine Urheberrechtsverletzung aufmerksam werden,
              bitten wir um einen entsprechenden Hinweis. Bei Bekanntwerden von
              Rechtsverletzungen werden wir derartige Inhalte umgehend
              entfernen.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Impressum;
